import styled from "styled-components";

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${(props) => (props.alignItems ? props.alignItems : "center")};
`;

const FlexColumnStart = styled(FlexColumn)`
  justify-content: flex-start;
`;

const FlexColumnCenter = styled(FlexColumn)`
  justify-content: center;
`;

const FlexColumnEnd = styled(FlexColumn)`
  justify-content: flex-end;
`;

const FlexColumnBetween = styled(FlexColumn)`
  justify-content: space-between;
`;

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: ${(props) => (props.alignItems ? props.alignItems : "center")};
`;

const FlexRowStart = styled(FlexRow)`
  justify-content: flex-start;
`;

const FlexRowCenter = styled(FlexRow)`
  justify-content: center;
`;

const FlexRowEnd = styled(FlexRow)`
  justify-content: flex-end;
`;

const FlexRowBetween = styled(FlexRow)`
  justify-content: space-between;
`;

const FlexContainers = {
  FlexColumn,
  FlexColumnStart,
  FlexColumnCenter,
  FlexColumnEnd,
  FlexColumnBetween,
  FlexRow,
  FlexRowStart,
  FlexRowCenter,
  FlexRowEnd,
  FlexRowBetween
};

export default FlexContainers;
